import React, { FunctionComponent } from 'react';

import cx from 'clsx';
import Image from 'next/image';

import styles from '../FreeConsultation/FreeConsultation.module.scss';
import commonStyles from './QuestionnairesCommon.module.scss';

export type QuestionnaireHeaderProps = {
  title: string;
  caption: string;
  withImage?: boolean;
};

export const QuestionnaireHeader: FunctionComponent<QuestionnaireHeaderProps> = ({
  title,
  caption,
  withImage = true,
}) => {
  return (
    <div className={cx(styles['free-consultation__header'], commonStyles.questionnaire__action)}>
      {withImage && <Image src="/icons/icon-succes.svg" alt={title} width={90} height={90} />}
      <h3 className={styles.questionnaire__label}>{title}</h3>
      <p>{caption}</p>
    </div>
  );
};
